export default __webpack_public_path__ + "static/B0165-f08cef9de7cf326a88ed29f9a1db666e.png";